<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="60%"
    top="10vh"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <span slot="title" class="title-container">
      <span class="title-text">{{factoryName + $t('factoryLabelPrint.templateContentEditing')}}</span>
      <img
        src="@/assets/close.png"
        class="close-image"
        @click="close"
      />
    </span>
    <el-form class="el-form" :model="form" ref="refForm" :rules="rules" label-width="120px">
      <el-form-item label-width="0">
        <el-col :span="10">
          <el-form-item :label="$t('common.boxNo') + ':'" prop="boxNo">
            {{form.customPartNo}}
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="10">
          <el-form-item :label="$t('factoryLabelPrint.specificationNo') + ':'" prop="partNo">
            <el-input
              v-model.trim="form.partNo"
              name="partNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$t('factoryLabelPrint.productionDate') + ':'" prop="deliveryDate">
            <el-date-picker
              v-model="form.deliveryDate"
              type="month"
              size="small">
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="10">
          <el-form-item :label="$t('factoryLabelPrint.qiangLiBatchNo') + ':'" prop="trackingNo">
            <el-input
              v-model.trim="form.trackingNo"
              name="batchNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
              placeholder="001-999">
              <template slot="prepend">IC56-{{deliveryDateVal}}</template>
              <el-select v-model="form.qiangLiAppend" slot="append" placeholder="请选择">
                <el-option label="无" value=""></el-option>
                <el-option label="-A" value="-A"></el-option>
                <el-option label="-A-SP" value="-A-SP"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$t('factoryLabelPrint.lotNoOfOutBox') + ':'" prop="lotNoOfOutBox">
            <el-input
              v-model.trim="form.lotNoOfOutBox"
              name="lotNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0" v-for="(item, index) in form.reserveInfo" :key="index">
        <el-col :span="10">
          <el-form-item :label="$t('common.lotNo') + ':'" :prop="'reserveInfo.' + index + '.lotNo'" :rules="rules.lotNo">
            <el-input
              v-model.trim="item.lotNo"
              name="lotNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$t('common.count')" :prop="'reserveInfo.' + index + '.cnt'" :rules="rules.count">
            <el-input
              v-model.trim.number="item.cnt"
              name="count"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-button type="text" @click="addReserve(index)" style="margin-left: 5px;">{{$t('common.add')}}</el-button>
          <el-button type="text" :disabled="form.reserveInfo.length === 1" @click="deleteReserve(index)">{{$t('common.delete')}}</el-button>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('common.stylePreview') + ':'" style="margin-bottom: 0">
      </el-form-item>
      <el-form-item>
        <el-col :span="15">
          <iframe
            id="historyLabelIFrameQiangliBoxDialog"
            scrolling="auto"
            width="520"
            height="260"
            frameborder="0"
            style="background: #E9E9E9;"
          ></iframe>
          <el-button style="position: absolute; margin-left: 10px;" size="small" @click="printQiangLiBoxLabelFrame">{{$t('common.print')}}</el-button>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button size="small" @click="close">{{$t('common.cancel')}}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submitForm">
            {{$t('common.sure')}}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
import {
  validateCount,
  validateLotNo,
} from '@/utils/validate';
import {initQiangLiBoxLabelFrame, printFactoryLabel} from "@/utils/factory-label";
import moment from "moment";
import i18n from "@/lang";
import {updateBox} from "@/api/boxLabel";
import {updateLabel} from "@/api/label";

export default {
  name: "QiangLiBoxLabelDialog",
  props: {
    factoryName: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    editRow: {
      type: Object,
      default: () => {},
    },
    isBoxLabel: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    const validateQiangLiBatchNo = (rule, value, callback) => {
      if (!/^(00[1-9]|0[1-9][0-9]|[1-9]\d{2})$/.test(value)) {
        callback(new Error(i18n.t('factoryLabelPrint.qiangLiBatchNoFormatIncorrect')));
        return;
      }
      callback();
    };
    return {
      form: {
        customPartNo: undefined,
        id: undefined,
        partNo: undefined,
        deliveryDate: undefined,
        trackingNo: undefined,
        qiangLiAppend: '',
        lotNoOfOutBox: undefined,
        reserveInfo: [{
          lotNo: undefined,
          cnt: undefined,
        }],
      },
      rules: {
        partNo: [{
          required: true,
          trigger: 'blur',
          message: this.$t('factoryLabelPrint.specificationNoCanNotBeEmpty')
        }],
        deliveryDate: [{
          required: true,
          trigger: 'blur',
          message: this.$t('factoryLabelPrint.productionDateCanNotBeEmpty')
        }],
        trackingNo: [{
          required: true,
          trigger: 'blur',
          message: this.$t('factoryLabelPrint.qiangLiBatchNoCanNotBeEmpty')
        }, {
          required: true,
          trigger: 'blur',
          validator: validateQiangLiBatchNo
        }],
        lotNoOfOutBox: [{
          required: true,
          trigger: 'blur',
          message: this.$t('factoryLabelPrint.lotNoOfOutBoxCanNotBeEmpty')
        }],
        lotNo: [{
          required: true,
          trigger: 'blur',
          validator: validateLotNo
        }],
        count: [{
          required: true,
          trigger: 'blur',
          validator: validateCount
        }],
      }
    }
  },
  watch: {
    editRow(newValue) {
      if (newValue && Object.keys(newValue).length > 0 && this.visible === true) {
        const {
          id,
          customPartNo,
          partNo,
          trackingNo,
          lotNo,
          reserve,
        } = newValue;
        let deliveryDate;
        let reserveInfo = [];
        let qiangLiAppend = '';
        if (trackingNo) {
          deliveryDate = trackingNo.substr(5, 4);
          if (deliveryDate) {
            deliveryDate = moment(deliveryDate,'YYMM').format('YYYY-MM-DD');
          }
          if (trackingNo.endsWith('-A')) {
            qiangLiAppend = '-A';
          } else if (trackingNo.endsWith('-A-SP')) {
            qiangLiAppend = '-A-SP';
          }
        }
        if (reserve) {
          try {
            reserveInfo = JSON.parse(reserve).info;
          } catch (e) {
            // do nothing.
          }
        }
        this.form = {
          id,
          customPartNo,
          partNo,
          deliveryDate,
          trackingNo: trackingNo ? trackingNo.substr(10, 3) : '',
          qiangLiAppend: qiangLiAppend,
          lotNoOfOutBox: lotNo,
          reserveInfo: reserveInfo
        };
        setTimeout(() => {
          this.initQiangLiBoxLabelFrame();
        });
      }
    }
  },
  computed: {
    deliveryDateVal() {
      const {
        deliveryDate,
      } = this.form;
      if (!deliveryDate) {
        return '';
      }
      return moment(deliveryDate).format('YYMM') + '-';
    }
  },
  methods: {
    handleDialogClose() {
      this.close();
    },
    close() {
      this.$emit('update:visible', false);
      this.$emit('close');
      if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
        this.$refs.refForm.clearValidate();
      }
    },
    addReserve(index) {
      this.form.reserveInfo.splice(index + 1, 0, {
        lotNo: undefined,
        cnt: undefined,
      });
    },
    deleteReserve(index) {
      this.form.reserveInfo.splice(index, 1);
      if (this.form.reserveInfo.length !== index) {
        this.$refs.refForm.validateField(['reserveInfo.' + index + '.lotNo', 'reserveInfo.' + index + '.cnt']);
      }
    },
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          if (this.isBoxLabel) {
            this.updateBox();
          } else {
            this.updateLabel();
          }
        }
      });
    },
    async updateBox() {
      const {
        id,
        partNo,
        lotNoOfOutBox,
        trackingNo,
        qiangLiAppend,
        reserveInfo,
      } = this.form;
      this.loading = true;
      try {
        await updateBox({
          boxLabelId: id,
          partNo,
          lotNo: lotNoOfOutBox,
          trackingNo: `IC56-${this.deliveryDateVal}${trackingNo}${qiangLiAppend || ''}` ,
          reserve: JSON.stringify({
            info: reserveInfo
          }),
        });
        this.$emit('update');
        this.close();
        this.$message({
          type: 'success',
          message: this.$t('common.updateSuccess'),
        });
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    async updateLabel() {
      const {
        id,
        partNo,
        materialNo,
        count,
        trackingNo,
        qiangLiAppend,
        deliveryDate,
      } = this.form;
      this.loading = true;
      try {
        await updateLabel({
          labelId: id,
          partNo: partNo,
          customPartNo: materialNo,
          qty: count,
          dateCode: moment(deliveryDate).format('YYYY-MM-DD'),
          trackingNo: `IC56-${this.deliveryDateVal}${trackingNo}${qiangLiAppend || ''}`,
        });
        this.$emit('update');
        this.close();
        this.$message({
          type: 'success',
          message: this.$t('common.updateSuccess'),
        });
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    initQiangLiBoxLabelFrame() {
      const {
        partNo,
        trackingNo,
        qiangLiAppend,
        lotNoOfOutBox,
        reserveInfo
      } = this.form;
      let iframe = document.getElementById('historyLabelIFrameQiangliBoxDialog');
      let i = 0;
      let lotNoIndex = 0;
      let info = [];
      for (let row of reserveInfo) {
        info.push(row);
        i++;
        if (i % 4 === 0) {
          lotNoIndex++;
          iframe = initQiangLiBoxLabelFrame({
            iframe,
            partNo,
            lotNo: lotNoOfOutBox,
            trackingNo: `IC56-${this.deliveryDateVal}${trackingNo}${qiangLiAppend || ''}` ,
            reserveInfo: info,
            index: lotNoIndex === 1 ? 0 : lotNoIndex, // 标签分页
            lotNoIndex: reserveInfo.length > 4 ? lotNoIndex : '',
          });
          info = [];
        }
      }
      if (info.length > 0) {
        lotNoIndex++;
        iframe = initQiangLiBoxLabelFrame({
          iframe,
          partNo,
          lotNo: lotNoOfOutBox,
          trackingNo: `IC56-${this.deliveryDateVal}${trackingNo}${qiangLiAppend || ''}` ,
          reserveInfo: info,
          index: lotNoIndex === 1 ? 0 : lotNoIndex, // 标签分页
          lotNoIndex: reserveInfo.length > 4 ? lotNoIndex : undefined,
        });
      }
      iframe.contentWindow.document.close();
    },
    printQiangLiBoxLabelFrame() {
      let iframe = document.getElementById('historyLabelIFrameQiangliBoxDialog');
      printFactoryLabel(iframe);
    }
  }
}
</script>

<style scoped>
.title-container {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: space-between;
  background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
  background: -o-linear-gradient(#F9F9F9, #EEEEEE);
  background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
  background: linear-gradient(#F9F9F9, #EEEEEE);
  padding: 10px 15px;
  align-items: center;
}

.title-text {
  color: #404040;
  font-size: 16px;
}

.el-form {
  margin: 0 30px;
}

.close-image {
  width: 22px;
  height: 22px;
  cursor: pointer;
  padding: 0 10px;
}
/deep/ .el-input-group__append {
  width: 70px;
}
</style>
<style>
  .edit-detail-dialog .el-dialog__header {
    padding: 0;
  }
</style>
